import { Checkbox } from '@synoptic/ui-kit/checkbox/checkbox.tsx';
import { black } from '@synoptic/ui-kit/palette.js';
import { COLORS } from './color-picker-colors.ts';
import {
  colorPickerContainer,
  colorsContainer,
  colorPickerLabel,
} from './list-form.css.ts';

type ColorPickerProps = {
  selectedColor?: string | null;
  onColorSelect: (color: string | null) => void;
  label: string;
};

export const ColorPicker = ({
  selectedColor,
  onColorSelect,
  label,
}: ColorPickerProps) => {
  return (
    <div className={colorPickerContainer}>
      <label className={colorPickerLabel}>{label}</label>
      <div className={colorsContainer} role="radiogroup" aria-label={label}>
        {COLORS.map((color) => (
          <Checkbox
            key={color.name}
            checked={selectedColor === color.name}
            onCheckedChange={() => onColorSelect(color.name)}
            aria-label={color.name}
            style={{
              backgroundColor: color.bgColor,
              color: black[900],
              borderColor: color.borderColor,
              borderRadius: '50%',
              aspectRatio: '1 / 1',
            }}
          />
        ))}
      </div>
    </div>
  );
};
